import type { User } from 'src/store';
import type { SignInPayload } from 'src/pages/auth/sign-in/schema';

import { formatError, axiosInstance } from './utils';

interface SignInApiResponse {
  user: User;
  redirectToPath?: string;
}

const USERS_BASE = '/users';

export async function signIn(data: SignInPayload): Promise<SignInApiResponse> {
  try {
    const response = await axiosInstance.post(`${USERS_BASE}/sign-in`, data);
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
}

export const getLoggedInUserInfo = async (): Promise<User> => {
  try {
    const { data } = await axiosInstance.get<User>(`${USERS_BASE}/my-info`);
    return data;
  } catch (error) {
    throw formatError(error);
  }
};

export const updateProfileColour = async (profileColour: string): Promise<User> => {
  try {
    const { data } = await axiosInstance.patch<User>(`${USERS_BASE}/profile-colour`, {
      profileColour,
    });
    return data;
  } catch (error) {
    throw formatError(error);
  }
};

export const signOut = async (): Promise<void> => {
  await axiosInstance.post(`${USERS_BASE}/sign-out`);
};

export interface AuthConfig {
  passwordLoginEnabled: boolean;
}

export const getAuthConfig = async (): Promise<AuthConfig> => {
  try {
    const { data } = await axiosInstance.get<AuthConfig>('/auth/config');
    return data;
  } catch (error) {
    throw formatError(error);
  }
};
